import Plyr from 'plyr';
import 'plyr/dist/plyr.css'

const heroBanner = () => {
	const elements = document.querySelectorAll('.row--hero-banner');
	if (!elements) return;

	elements.forEach((element) => {
		const plyrElement = element.querySelector('.plyr__video-embed');
		const videoWrapper = element.querySelector('.row__bgVideo');
		if (plyrElement && videoWrapper) {
			const bgPlyr = new Plyr(plyrElement, {
				muted: true,
				loop: { active: true },
				controls: []
			});
			setTimeout(() => {
				bgPlyr.play();
				videoWrapper.classList.add('loaded');
			}, 1000);
		}
	});
}

export default heroBanner;
